import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import StatementDoc from "@/components/StatementDoc";
import { Wallet, Printer, FileDown, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicStatement() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    axios.get(`${API}/public/statements/${token}`)
      .then(({ data }) => { setData(data); setStatus("ok"); })
      .catch(() => setStatus("error"));
  }, [token]);

  const downloadPdf = () => window.open(`${API}/public/statements/${token}/pdf`, "_blank");

  if (status === "loading")
    return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-indigo-600" size={32} /></div>;
  if (status === "error")
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 p-6 text-center">
        <div>
          <h1 className="text-xl font-heading font-bold text-slate-800">Statement unavailable</h1>
          <p className="text-slate-500 mt-1">This link is invalid or has been revoked by the sender.</p>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-slate-100 py-6 px-3">
      <div className="max-w-3xl mx-auto flex items-center justify-between mb-4 no-print">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-indigo-600 grid place-items-center"><Wallet size={16} className="text-white" /></div>
          <span className="font-heading font-extrabold text-slate-900">SyncPe</span>
        </div>
        <div className="flex gap-2">
          <button onClick={() => window.print()} className="px-3 py-2 rounded-xl border border-slate-200 bg-white font-semibold text-sm flex items-center gap-2"><Printer size={16} /> Print</button>
          <button data-testid="public-pdf-btn" onClick={downloadPdf} className="px-3 py-2 rounded-xl bg-indigo-600 text-white font-semibold text-sm flex items-center gap-2"><FileDown size={16} /> PDF</button>
        </div>
      </div>
      <div className="max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-lg print-area">
        <StatementDoc data={data} />
      </div>
      <p className="text-center text-xs text-slate-400 mt-4 no-print">Shared securely via SyncPe</p>
    </div>
  );
}
